export default __webpack_public_path__ + "static/media/usersIcon.93490fcf.svg";